import React from 'react';
import Box from '@material-ui/core/Box';

const TabPanel = ({
  children,
  id,
  activateId,
  ...rest
}) => (
  <Box
    hidden={id !== activateId}
    id={id}
    {...rest} // eslint-disable-line
  >
    {children}
  </Box>
);

export default TabPanel;
